module.exports = __webpack_public_path__ + "img/日本の日用雑貨や食品・サプリメント等を、国外の商社へ販売する事業を行っております。 当社とのお取引を検討されている商社・メーカ.354c4679.png";